import { MainContent, TopBar } from '@domain-group/suit-theme'

import useMainNavigation from '@hooks/useMainNavigation'

import DashboardSearch from '@components/DashboardSearch'
import LoggedInUser from '@components/LoggedInUser'
import MainNavigation from '@sections/Client/components/MainNavigation'
import Notifications from '@components/Notifications'

import OverviewsNavigation from './components/OverviewsNavigation'

import OverviewsRoutes from './routes'

const Overviews = () => {
  const { callbacks: { toggleNavigation } } = useMainNavigation()

  return (
    <>
      <TopBar
        callbacks={{ toggleNavigation }}
        loggedInUserComponent={<LoggedInUser />}
        nestedNavigation
        notificationsComponent={<Notifications />}
        searchComponent={<DashboardSearch />}
      />

      <MainNavigation minimized nestedNavigation={<OverviewsNavigation />} />

      <MainContent nestedNavigation offset={{ top: TopBar.topBarHeight }}>
        <OverviewsRoutes />
      </MainContent>
    </>
  )
}

export default Overviews
